// Sourced namespace models
// NB This file is auto generated, do not manually alter!

  import type { CallOffRecipient } from "./types";
  import type { DimensionBlock } from "./types";
  import type { OrderLine } from "./types";
  import type { CancelFunction } from "./types";
  import type { ChangeFunction } from "./types";
  import type { DetailsSubSection } from "./types";
  import type { DetailsSubSectionGeneral } from "./types";
  import type { Dimension } from "./types";
  import type { OrderLineExtended } from "./types";
  import type { RecipientResult } from "./types";


  export const DefaultCallOffRecipient : CallOffRecipient = {
    identifier: undefined,
    emailAddress: undefined,
    mobileNumber: undefined,
    firstName: undefined,
    lastName: undefined,
    address1: undefined,
    address2: undefined,
    zipCode: undefined,
    city: undefined,
    countryId: undefined,
    languageId: undefined,
    doorAccessCode: undefined,
  }

  export const DefaultDimensionBlock : DimensionBlock = {
    titleHint: '',
    labels: [],
  }

  export const DefaultOrderLine : OrderLine = {
    id: 0,
    customerOrderNo: undefined,
    warehouseOrderNo: undefined,
    shipmentNo: '',
    lineNumber: '',
    articleNo: '',
    name: '',
    orderedQuantity: undefined,
    pickedQuantity: undefined,
    canceledQuantity: undefined,
    returnedQuantity: undefined,
    lineType: 0,
  }

  export const DefaultCancelFunction : CancelFunction = {
    cancelShipment: false,
  }

  export const DefaultChangeFunction : ChangeFunction = {
    extendAccessPointDays: false,
    changeName: false,
    changeAddress: false,
    changePhone: false,
    changeEmail: false,
    changeDoorAccessCode: false,
    leaveOutsideDoor: false,
    knockOnDoor: false,
    noIdRequirement: false,
    messageToDriver: false,
    changeLockerLocation: false,
    newDeliveryAttempt: false,
  }

  export const DefaultDetailsSubSection : DetailsSubSection = {
    position: 0,
    dataGroup: '',
    blocks: [],
  }

  export const DefaultDetailsSubSectionGeneral : DetailsSubSectionGeneral = {
    position: 0,
    dataGroup: '',
    blocks: [],
    dimensions: DefaultDimensionBlock,
    carrierId: 0,
    shipmentGroupNo: undefined,
    shipmentGroupCarrierId: undefined,
    shipmentGroupObjectId: undefined,
    shipmentCarrierTrackerLink: undefined,
    mType: 0,
  }

  export const DefaultDimension : Dimension = {
    number: 0,
    id: undefined,
    name: undefined,
    valueId: undefined,
  }

  export const DefaultOrderLineExtended : OrderLineExtended = {
    id: 0,
    customerOrderNo: undefined,
    warehouseOrderNo: undefined,
    shipmentNo: '',
    lineNumber: '',
    articleNo: '',
    name: '',
    orderedQuantity: undefined,
    pickedQuantity: undefined,
    canceledQuantity: undefined,
    returnedQuantity: undefined,
    lineType: 0,
    carrierReferenceNo: '',
    carrierId: '',
    carrierServiceCode: '',
    shipmentDate: undefined,
    customerOrderLineNumber: '',
    shipmentLineNumber: '',
    supplierArticleNo: '',
    customerArticleNo: '',
    description: '',
    category1: '',
    category2: '',
    shipmentLineReference: '',
    noOfPackages: undefined,
    unit: '',
    price: undefined,
    discount: undefined,
    tax: undefined,
    freightCost: undefined,
    totalPrice: undefined,
    totalDiscount: undefined,
    totalTax: undefined,
    totalFreightCost: undefined,
    currency: '',
    weight: undefined,
    totalWeight: undefined,
    weightUnit: '',
    volume: undefined,
    totalVolume: undefined,
    volumeUnit: '',
    productUrl: '',
    imageUrl: '',
    dangerousGoods: '',
    typeOfGoods: '',
    typeOfTransport: '',
    plannedDispatchDate: undefined,
    receivedQuantity: undefined,
    insertByUserFullname: '',
    updateByUserFullname: '',
    insertDate: '',
    updateDate: '',
    log: [],
  }

  export const DefaultRecipientResult : RecipientResult = {
    mBoxId: 0,
    ourboxesIdentifier: '',
    email: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    identifier: '',
    address1: '',
    address2: '',
    zipCode: '',
    city: '',
    country: undefined,
    doorAccessCode: '',
    languageId: undefined,
  }

